import $ from "jquery";

export const init = () => {
  $("[data-id='copy-iban']").on("click", (e) => {
    let $parent = $(e.target).parents(".container");
    let $feedback = $parent.find(".IBAN-feedback");
    let $temp = $("<input>");

    $("body").append($temp);
    $temp.val($("[data-id='iban-copy']").text()).select();
    document.execCommand("copy");
    $temp.remove();
    $feedback.slideDown(400, () => {
      setTimeout(() => {
        $feedback.slideUp(400);
      }, 5000);
    });
  });
};
